<div id="content-desktop">
  <header>


    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 1%; padding-bottom: 1%; width: 10% " class="img-responsive">
            <img src="../../../assets/D URL 2.png" style="width: 40%; position: absolute; top: 25%; " class="img-responsive" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../../assets/D Beef Phone.png" style="width: 15%; display: block; margin-left: auto; top: 50%;" class="right" />
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #d64038 ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold">Notice/FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File A Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact-information']" style="color:white; font-weight: bold ">Contact Information</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>


  </header>
</div>


<div class="container" style="border:1px solid #bebaba">
  <br />
  <h3><b>Court Documents</b></h3>
  <br />
  <b>Tyson Settlement</b>
  <ul>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1565 DPPs' Mtn Prelim Approval Settlmt Tyson & Ntc Plan 04-17-26.pdf"
         target="_blank">
        Motion for Preliminary Approval of Settlement with Tyson Defendants and Approval of Notice Plan ad Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1566 DPPs' Ntc of Mtn Prelim Approval Settlmt Tyson & Ntc Plan04-17-26.pdf"
         target="_blank">
        Notice of Hearing on Plaintiffs' Motion for Preliminary Approval of Settlement and Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1567 DPPs' Memo ISO Mtn Prelim Approval Settlmt Tyson & Ntc Plan.pdf"
         target="_blank">
        Memorandum of Law in Support of Motion for Preliminary Approval of Settlement with Tyson Defendants and Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1567-1 Word Count Cert.pdf"
         target="_blank">
        Direct Purchaser Plaintiffs' Rule 7.1(f) Compliance Certificate
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1568 Decl. M. Jones ISO DPPs' Mtn Prelim Approval Settlmt Tyson and Ntc Plan.pdf"
         target="_blank">
        Declaration of Megan E. Jones in Support of Motion for Preliminary Approval of Settlement and Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1568-1 Ex. A - Settlement Agreement DPPs-Tyson.pdf"
         target="_blank">
        Settlement Agreement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1569 Decl. B. Devery ISO DPPs' Mtn Prelim Approval Tyson Settlmt & Ntc Plan.pdf"
         target="_blank">
        Declaration of Brian Devery in Support of Motion for Approcal of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1570 Meet and Confer Statement.pdf"
         target="_blank">
        Meet and Confer Statement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1571 Proposed Order Granting DPPs' Mtn Prelim Approval Tyson Settlement and Ntc Process 04-17-26.pdf"
         target="_blank">
        Proposed Order Regarding Motion for Preliminary Approval of Settlement and Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc 1621 Order Modifying Notice Schedule.pdf"
         target="_blank">
        Order Modifying Notice Schedule
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1635 DPPs Mtn for Fees.pdf"
         target="_blank">
        Motion for Interim Payment of Attorney's Fees and Service Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1637 Memo ISO DPPs Mtn for Fees.pdf"
         target="_blank">
        Memorandum of Law in Support of Motion for Interim Payment of Attorney's Fees and Service Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1638 D. Gustafson Decl re Mtn for Fees.pdf"
         target="_blank">
        Declaration of D. E. Gustafson in Support of  Motion for Interim Payment of Attorney's Fees and Service Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc 1638-1 Ex A GG Time Report.pdf"
         target="_blank">
        Exhibit A - Gustafson Gluek PLLC Time Report
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1638-2 Ex B DPP Lodestar Summary.pdf"
         target="_blank">
        Exhibit B - DPP's Counsel Summary of Cumulative Hours and Lodestar
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1638-3 Ex 1 - 14 DPP Counsel Decl and Lodestar Summaries.pdf"
         target="_blank">
        Exhibit 1 - Declaration of A. J. Zapala in Support of  Motion for Interim Payment of Attorney's Fees and Service Awards on Bhalf of Cotchett, Pitre & McCarthy LLP
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1639 Meet and Confer re Mtn for Fees.pdf"
         target="_blank">
        Meet and Confer Statement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1640 Proposed Order re Mtn for Fees.pdf"
         target="_blank">
        Proposed Order Regarding Motion for Interim Payment of Attorney's Fees and Service Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/ORder.pdf"
         target="_blank">
        Order Granting Motion to Modify Notice Plan and Notice Schedule
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit A (Modified Long Form Notice).pdf"
         target="_blank">
        Exhibit A to Motion to Modify Notice and Notice Schedule (Amended Long Form Notice)
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit B (Modified Short Form Notice).pdf"
         target="_blank">
        Exhibit B to Motion to Modify Notice and Notice Schedule (Amended Short Form Notice)
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit D (Modified Blank Claim Form).pdf"
         target="_blank">
        Exhibit D to Motion to Modify Notice and Notice Schedule (Amended Blank Claim Form)
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit E (Modified Prepopulated Claim Form).pdf"
         target="_blank">
        Exhibit E to Motion to Modify Notice and Notice Schedule (Amended Prepopulated Claim Form)
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit F (Modified Audit Request Form).pdf"
         target="_blank">
        Exhibit F to Motion to Modify Notice and Notice Schedule (Amended Audit Request Form)
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1699 DPPs Amd Mtn for Fees.pdf"
         target="_blank">
        Amended Motion for Interm Payment of Attorneys' Fees, Reimbursement of Litigation Expenses, Service Awards, and Establishment of a Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1700 Memo ISO Amd Mtn for Fees.pdf"
         target="_blank">
        Memorandum in Support of Amended Motion for Interm Payment of Attorneys' Fees, Reimbursement of Litigation Expenses, Service Awards, and Establishment of a Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1700-1 Word Count Cert re Memo ISO Mtn for Fees.pdf"
         target="_blank">
        DPP Rule 7.1(f) Compliance Certificate
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1701 D. Gustafson Decl ISO Amd Mtn for Fees.pdf"
         target="_blank">
        Declaration of D. E. Gustafson in Support of Amended Motion for Interm Payment of Attorneys' Fees, Reimbursement of Litigation Expenses, Service Awards, and Establishment of a Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1701-1 Ex A-D re D. Gust Decl ISO Amd Mtn for Fees.pdf"
         target="_blank">
        Exhibit A - Time Report
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1701-2 Ex 1-14 re D. Gust Decl ISO Amd Mtn for Fees.pdf"
         target="_blank">
        Exhibit 1 - Declaraton of A. J. Zapala in Support of Amended Motion for Interm Payment of Attorneys' Fees, Reimbursement of Litigation Expenses, Service Awards, and Establishment of a Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1702 M&C re Amd Mtn for Fees.pdf"
         target="_blank">
        Meet and Confer Statement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Doc. 1703 Proposed Order re Amd Mtn for Fees.pdf"
         target="_blank">
        Proposed Order of the Amended Motion for Interm Payment of Attorneys' Fees, Reimbursement of Litigation Expenses, Service Awards, and Establishment of a Litigation Fund
      </a>
    </li>







    <li>
      <a href="../../../assets/documents/courtdocs/1731.pdf"
         target="_blank">
        Memorandum in Support of Motion for Final Approval of Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/2026-11-02 (1731-1) Rule 7.1(f) Compliance Certificate.pdf"
         target="_blank">
        Direct Purchase Plaintiffs' Rule 7.1(f) Compliance Certificate
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/1732.pdf"
         target="_blank">
        Meet and Confer Statement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/1733.pdf"
         target="_blank">
        Declaration of M. E. Jones in Support of Motion for Final Approval of Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/2026-11-02 (1733-1) Exhibit(s) A.pdf"
         target="_blank">
        Exhibit A: Long Form Settlement Agreement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/1734.pdf"
         target="_blank">
        Declaration of A. Diring in Support of Motion for Final Approval of Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/2026-11-02 (1734-1) Exhibit(s) A - G.pdf"
         target="_blank">
        Exhibit A-G
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/2026-11-02 (1735) Proposed Order [1613] DPP Mot for Final Approval - Tyson's Defs'.pdf"
         target="_blank">
        Proposed Order Regarding Motion for Final Approval of Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/0_22-md-03031-JRT-JFD_1667_PRIMARY DOCUMENT.pdf"
         target="_blank">
        Amended Notice of Hearing on Motion for Final Approcal of Settlement with Tyson Defendants and Entry of Final Judgment, and Motion for Interim Attorneys' Fees, Costs, Service Awards, and to Establish a Litigation Fund
      </a>
    </li>
  </ul>


  <b>JBS Claims Process</b>
  <ul>
    <li>
      <a href="../../../assets/documents/courtdocs/ECF 353 - DPP Motion for Approval of Notice Plan and Claims Process.pdf"
         target="_blank">
        DPP Motion for Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/ECF 354 - DPPs' Notice of Hearing on Mtn for Approval of Notice Plan and Claims Process.pdf"
         target="_blank">
        DPPs' Notice of Hearing on Mtn for Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/ECF 358 - Proposed Order Granting DPP Motion for Approval of Notice Plan and Claims Process.pdf"
         target="_blank">
        Memo in Support of DPPs' Motion for Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Memo ISO Compliance Certificate.pdf"
         target="_blank">
        DPP Rule 7.1(f) Compliance Certificate
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of E. Schachter ISO Motion for Final Approval JBS.pdf"
         target="_blank">
        Schachter Declaration ISO DPP Motion for Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Meet and Confer Statement.pdf"
         target="_blank">
        Meet and Confer Statement 09-29-23
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Proposed Order Granting DPPs' Motion Final Approval Settlement with JBS.pdf"
         target="_blank">
        Proposed Order Granting DPP Motion for Approval of Notice Plan and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Amended order Granting DPP Motion for Approval of Claims Process.pdf"
         target="_blank">
        Amended order Granting DPP Motion for Approval of Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Notice of Hearing on Motion Interim Fees & Service Awards.pdf"
         target="_blank">
        Notice of Hearing on Motion Interim Fees & Service Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/DPPs Memo ISO Motion Interim Fees & Service Awards with Compliance Cert.pdf"
         target="_blank">
        DPPs Memo ISO Motion Interim Fees & Service Awards with Compliance Cert
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of D. Gustafson ISO DPPs' Motion Interim Fees with Exhibits.pdf"
         target="_blank">
        Declaration of D. Gustafson ISO DPPs' Motion Interim Fees with Exhibits
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Meet and Confer Statement 1.30.2024.pdf"
         target="_blank">
        Meet and Confer Statement 1.30.2024
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Proposed Order re DPPs Motion for Interim Fees & Awards.pdf"
         target="_blank">
        Proposed Order re DPPs Motion for Interim Fees & Awards
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Status Update re Notice Program and Claims Process.pdf"
         target="_blank">
        Status Update Regarding Direct Purchaser Plaintiffs Notice Program and Claims Process
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Plaintiffs' Amended Motion to Distribute.pdf"
         target="_blank">
        Plaintiffs' Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Notice of Hearing on Amended Motion to Distribute.pdf"
         target="_blank">
        Notice of Hearing on Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Plaintiffs' Memorandum in Suppor of Amended Motion to Distribute.pdf"
         target="_blank">
        Plaintiffs' Memorandum in Suppor of Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of Michelle Looby in Support of Plaintiff's Amended Motion to Distribute.pdf"
         target="_blank">
        Declaration of Michelle Looby in Support of Plaintiff's Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of Brian Devery in Support of Plaintiff's Amended Motion to Distribute.pdf"
         target="_blank">
        Declaration of Brian Devery in Support of Plaintiff's Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Meet and Confer Statement 2.20.2026.pdf"
         target="_blank">
        Meet and Confer Statement 2.20.2026
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Proposed Order Regarding Plaintiff's Amended Motion to Distribute.pdf"
         target="_blank">
        Proposed Order Regarding Plaintiff's Amended Motion to Distribute
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Beef - Order Granting JBS Distro Motion.pdf"
         target="_blank">
        Order Granting Motion to Distribute Net Settlement Proceeds
      </a>
    </li>
  </ul>

  <b>JBS Settlement</b>
  <ul>
    <li>
      <a href="../../../assets/documents/courtdocs/Settlement Agreement.pdf"
         target="_blank">
        Settlement Agreement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Motion for Preliminary Approval.pdf"
         target="_blank">
        Motion for Preliminary Approval
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Preliminary approval order.pdf"
         target="_blank">
        Preliminary Approval Order
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Amended Order- ECF 494.pdf"
         target="_blank">
        Preliminary Approval Order- Amended
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Notice of Hearing on Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Notice of Hearing on Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Memo in Support of Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Memo in Support of Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Memo ISO Compliance Certificate.pdf"
         target="_blank">
        Memo ISO Compliance Certificate
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of M. Looby in Support of Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Declaration of M. Looby in Support of Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Exhibit 1 to Declaration of M. Looby in Support of Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Exhibit 1 to Declaration of M. Looby in Support of Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Meet and Confer Statement.pdf"
         target="_blank">
        Meet and Confer Statement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Proposed Order Granting Motion to Establish Litigation Fund.pdf"
         target="_blank">
        Proposed Order Granting Motion to Establish Litigation Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Motion for Final Approval of Settlement with JBS.pdf"
         target="_blank">
        Motion for Final Approval of Settlement with JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Notice of Hearing on Motion for Final Approval JBS Settlement.pdf"
         target="_blank">
        Notice of Hearing on Motion for Final Approval JBS Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Memo ISO Motion for Final Approval Settlement with JBS.pdf"
         target="_blank">
        Memo ISO Motion for Final Approval Settlement with JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of D. Gustafson ISO Motion for Final Approval Settlement JBS.pdf"
         target="_blank">
        Declaration of D. Gustafson ISO Motion for Final Approval Settlement JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Exhibit A-C to D. Gustafson Declaration.pdf"
         target="_blank">
        Exhibit A-C to D. Gustafson Declaration
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Declaration of E. Schachter ISO Motion for Final Approval JBS.pdf"
         target="_blank">
        Declaration of E. Schachter ISO Motion for Final Approval JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Exhibits A-G to E. Schachter Declaration.pdf"
         target="_blank">
        Exhibits A-G to E. Schachter Declaration
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Proposed Order Granting DPPs' Motion Final Approval Settlement with JBS.pdf"
         target="_blank">
        Proposed Order Granting DPPs' Motion Final Approval Settlement with JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Order Granting DPPs' Mtn for Establishment of Lit Expense Fund.pdf"
         target="_blank">
        Order Granting DPPs' Mtn for Establishment of Lit Expense Fund
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Order Granting DPPs' Mtn for Final Approval Settlement w-JBS.pdf"
         target="_blank">
        Order Granting DPPs' Mtn for Final Approval Settlement w-JBS
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/Amended Order Granting Final Approval of JBS Settlement.pdf"
         target="_blank">
        Amended Order Granting Final Approval of JBS Settlement
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/705 - Order approving fees.pdf"
         target="_blank">
        Order Granting DPP Motion for Interim Payment and Service Awards
      </a>
    </li>
  </ul>

  <b>Complaint</b>
  <ul>
    <li>
      <a href="../../../assets/documents/courtdocs/Operative Complaint.pdf"
         target="_blank">
        Operative Complaint
      </a>
    </li>
  </ul>
</div>








